/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignedProviderTemplateApiModel } from './assignedProviderTemplateApiModel';


export interface TenantTemplatesDetailApiModel { 
    employerTemplateId?: number | null;
    providerTemplates: Array<AssignedProviderTemplateApiModel>;
}

